import { DesignTokenOrigin, DesignTokenOriginPart, DesignTokenTypedData, } from "../elements";
import { ImportModelBase, ImportModelInputBase } from "./base";
import { z } from "zod";
//
// Base
//
const DesignTokenImportModelPart = z.object({
    collectionId: z.string().optional(),
    codeSyntax: z.record(z.coerce.string()).optional(),
    scopes: z.array(z.string()).optional(),
});
export const DesignTokenImportModelBase = ImportModelBase.extend(DesignTokenImportModelPart.shape).extend({
    origin: DesignTokenOrigin,
});
export const DesignTokenImportModelInputBase = ImportModelInputBase.extend(DesignTokenImportModelPart.shape).extend({
    originMetadata: DesignTokenOriginPart,
});
//
// Import models
//
export const DesignTokenImportModel = DesignTokenTypedData.and(DesignTokenImportModelBase);
export const DesignTokenImportModelInput = DesignTokenTypedData.and(DesignTokenImportModelInputBase);
export function isDesignTokenImportModelOfType(designToken, type) {
    return designToken.type === type;
}
export function designTokenImportModelTypeFilter(type) {
    return (designToken) => isDesignTokenImportModelOfType(designToken, type);
}
